import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ItHeaderComponent, ItIconComponent, ItNavBarComponent, ItNavBarItemComponent } from 'design-angular-kit';
import { HeaderService } from './header.service';
import { Header } from '../types/Header';
import { SicotService } from '../sicot.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [ItNavBarItemComponent, ItIconComponent, ItHeaderComponent, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  username: string | null = null
  light = false;
  sticky = false;
  search = false;
  login = 'none';
  headers: Header[] = [];
  numeroNotificheNonLette: number = 0;

  constructor(
    private headerService: HeaderService,
    private siCotService: SicotService,
    private oauthService: OAuthService,
    private router: Router
  ) {
  }

  logout(): void {
    const logoutUrl = this.oauthService.logoutUrl;
    console.log('Tentativo di logout. Endpoint di WSO2:', logoutUrl);

    if (!logoutUrl) {
      console.warn("Attenzione: logoutUrl non configurato. Il redirect a WSO2 non avverrà mai!");
    }

    this.oauthService.logOut();
  }

  async ngOnInit() {
    this.getFooter();
    this.fetchNumeroNotificheNonLette();
    this.username = this.siCotService.getUsername();

    if (this.oauthService.hasValidAccessToken()) {
      console.log('id_token claims', this.oauthService.getIdentityClaims());
      await this.oauthService.loadUserProfile(); // chiama /userinfo
      console.log('after userinfo claims', this.oauthService.getIdentityClaims());
    }
  }

  getFooter() {

  }

  getValore(chiave: string) {
    let valore = this.headers.find(header => header.chiave === chiave)?.valore || '';
    return valore;
  }

  /** Username da SicotService (impostato dopo login OAuth), da OAuth claims, o fallback "Utente". */
  getUtente(): string {
    const fromSicot = this.siCotService.getUsername();
    if (fromSicot) return fromSicot;
    const claims = this.oauthService.getIdentityClaims() as Record<string, unknown> | null;
    const fromClaims = claims?.['preferred_username'] ?? claims?.['name'] ?? claims?.['sub'];
    if (fromClaims && typeof fromClaims === 'string') return fromClaims;
    return 'Utente';
  }

  fetchNumeroNotificheNonLette(): void {
    this.siCotService.getNumeroNotificheNonLette().subscribe(
      (data) => {
        this.numeroNotificheNonLette = data;
      },
      (error) => {
        console.error('Error fetching qualifiche:', error);
      }
    );
  }

}
